import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

const IndicatorsTable = ({ indicators }) => {
  const { theme } = useTheme();

  if (!Array.isArray(indicators) || indicators.length === 0) {
    return (
      <CustomCard>
        <div className="flex flex-col items-center justify-center py-12">
          <p
            className={`text-sm ${theme === 'dark' ? 'text-[#7F7F7F]' : 'text-[#878787]'
              }`}
          >
            No Technical Indicators Available.
          </p>
        </div>
      </CustomCard>
    );
  }

  const formatNumber = (num) =>
    Number(num).toLocaleString('en-IN', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });

  const parseValue = (value) => {
    if (!value) return '-';
    try {
      const parsed = JSON.parse(value);

      if (parsed.Value != null) {
        return formatNumber(parsed.Value);
      }

      if (
        parsed['Upper band'] != null &&
        parsed['Middle band'] != null &&
        parsed['Lower band'] != null
      ) {
        return (
          <div className="leading-5 text-right">
            <div>U: {formatNumber(parsed['Upper band'])}</div>
            <div>M: {formatNumber(parsed['Middle band'])}</div>
            <div>L: {formatNumber(parsed['Lower band'])}</div>
          </div>
        );
      }

      return '-';
    } catch {
      return '-';
    }
  };

  const getSignalColor = (level) => {
    if (!level) return '';
    const l = level.toLowerCase();
    if (l.includes('bullish')) return 'text-green-500';
    if (l.includes('bearish')) return 'text-red-500';
    if (l.includes('neutral')) return 'text-yellow-500';
    return theme === 'dark' ? 'text-[#AFAFAF]' : 'text-[#575757]';
  };

  return (
    <CustomCard>
      <div className="overflow-x-auto -mx-4">
        <table className="w-full">
          <thead>
            <tr
              className={`border-b ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
                }`}
            >
              {/* Type */}
              <th
                className={`w-1/4 pl-6 pr-3 py-2 text-left text-sm font-medium text-n500`}
              >
                Type
              </th>


              {/* Current Price */}
              <th
                className={`w-1/4 px-3 py-2 text-right text-sm font-medium text-n500`}
              >
                Current Price
              </th>

              {/* Computed Value */}
              <th
                className={`w-1/4 px-3 py-2 text-right text-sm font-medium text-n500`}
              >
                Computed Value
              </th>

              {/* Level */}
              <th
                className={`w-1/4 pl-3 pr-6 py-2 text-right text-sm font-medium text-n500`}
              >
                Level
              </th>
            </tr>
          </thead>

          <tbody>
            {indicators.map((row, index) => (
              <tr
                key={index}
                className={`border-b ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
                  }`}
              >
                {/* Type */}
                <td
                  className={`w-1/4 pl-6 pr-3 py-3 text-sm ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'
                    }`}
                >
                  <div className="font-medium">{row.indicator}</div>
                  <div
                    className={`text-xs ${theme === 'dark'
                      ? 'text-[#7F7F7F]'
                      : 'text-[#878787]'
                      }`}
                  >
                    {row.full_name}
                  </div>
                </td>


                {/* LTP */}
                <td
                  className={`w-1/4 px-3 py-3 text-sm font-medium text-right ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'
                    }`}
                >
                  {formatNumber(row.ltp)}
                </td>

                {/* Value */}
                <td
                  className={`w-1/4 px-3 py-3 text-sm font-medium text-right ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'
                    }`}
                >
                  {parseValue(row.value)}
                </td>

                {/* Level */}
                <td
                  className={`w-1/4 pl-3 pr-6 py-3 text-sm text-right font-medium text-p300`}
                >
                  {row.level}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CustomCard>
  );
};

export default IndicatorsTable;
